import React from 'react';

interface ImageUploadProps {
  methods: any;
  selectedImage: string | null;
  setSelectedImage: React.Dispatch<React.SetStateAction<string | null>>;
  label?: string;
  ratioInfo?: string;
  error: any;
  name: string;
}

const ImageUploadInput: React.FC<ImageUploadProps> = ({
  methods,
  selectedImage,
  setSelectedImage,
  name,
  label,
  ratioInfo,
  error
}) => {
  // Handler to update the selected image
  const handleImageChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files[0]) {
      setSelectedImage(URL.createObjectURL(e.target.files[0]));
      methods.setValue('image', e.target.files[0]);
    }
  };

  // Handler to remove the selected image
  const handleImageRemove = () => {
    setSelectedImage(null);
    methods.setValue('image', '');
  };

  return (
    <div className="flex flex-col items-start pb-4 text-sm">
      <label className="text-neutral9 font-semibold" htmlFor="image">
        {label}
      </label>
      {selectedImage ? (
        <div className="flex flex-col space-y-2">
          <div className="flex items-center space-x-4">
            <img src={selectedImage} alt="Selected" className="w-52 h-24 object-cover" />
            <button
              type="button"
              className="text-secondary2 underline px-4 py-2 rounded"
              onClick={handleImageRemove}
            >
              Remove Image
            </button>
          </div>
          <div className="flex justify-start w-full">
            <label
              htmlFor="replaceImage"
              className="w-1/2 mt-1 text-primary1 px-4 py-2 font-semibold rounded-lg border-2 text-center cursor-pointer"
            >
              Replace Image
            </label>
            <input
              type="file"
              id="replaceImage"
              name="replaceImage"
              className="hidden"
              onChange={handleImageChange}
            />
          </div>
        </div>
      ) : (
        <input type="file" name={name} onChange={handleImageChange} className="input" />
      )}
      {error && (
        <span className="error" role="alert">
          {error.message}
        </span>
      )}
      <p className="mt-2 text-neutral7 text-xs font-semibold whitespace-normal">{ratioInfo}</p>
    </div>
  );
};

export default ImageUploadInput;
